import React from "react";
import { NavLink } from "react-router-dom";

import Icon from "../../components/Icon";
import Page from "../../components/Page";

/**
 * Komponente um statische Inhalte auszugeben
 */
class NoMatch extends React.Component
{
	render()
	{
		const title = this.props.errorCode ? this.props.errorCode : "404";
		
		return <Page title={title} pageUrl={`/${title}`}>
				{
					this.props.errorCode === "401" &&
					<div className={"col s12 error"}>
						<div className={"col s4"}>
							<div className={"row"}><Icon className={"col s12 center primary-color-text"} size={"300"} iconName={"logout"}/></div>
						</div>
						<div className={"col s8"}>
							<h3>Entschuldigung, Sie haben keine gültige Authentifizierung für diese Seite!,</h3>
							<p>Hier kommen Sie zurück zur</p>
							<NavLink className={"btn"} to="/"><Icon color="#fff" iconName={"leave"}/><span>Startseite</span></NavLink>
							<div className={"right bottom"}>
								<h2 className={"unset-padding"}>401 Error!</h2>
								<h3 className={"unset-padding"} style={{ marginLeft: 14 + "px" }}>Keine gültige Authentifizierung!</h3>
							</div>
						</div>
					</div>
				}
				{
					this.props.errorCode === "402" &&
					<div className={"col s12 error"}>
						<div className={"col s4"}>
							<div className={"row"}><Icon className={"col s12 center primary-color-text"} size={"300"} iconName={"payment"}/></div>
						</div>
						<div className={"col s8"}>
							<h3>Entschuldigung, Sie haben kein gültiges Abbonement für diese Seite!</h3>
							<p>Hier kommen Sie zurück zur</p>
							<NavLink className={"btn"} to="/"><Icon color="#fff" iconName={"leave"}/><span>Startseite</span></NavLink>
							<div className={"right bottom"}>
								<h2 className={"unset-padding"}>402 Error!</h2>
								<h3 className={"unset-padding"} style={{ marginLeft: 14 + "px" }}>Bezahlung benötigt!</h3>
							</div>
						</div>
					</div>
				}
				{
					this.props.errorCode === "403" &&
					<div className={"col s12 error"}>
						<div className={"col s4"}>
							<div className={"row"}><Icon className={"col s12 center primary-color-text"} size={"300"} iconName={"logout"}/></div>
						</div>
						<div className={"col s8"}>
							<h3>Entschuldigung, Sie haben keine gültige Berechtigung für diese Seite!</h3>
							<p>Hier kommen Sie zurück zur</p>
							<NavLink className={"btn"} to="/"><Icon color="#fff" iconName={"leave"}/><span>Startseite</span></NavLink>
							<div className={"right bottom"}>
								<h2 className={"unset-padding"}>403 Error!</h2>
								<h3 className={"unset-padding"} style={{ marginLeft: 14 + "px" }}>Fehlende Berechtigung!</h3>
							</div>
						</div>
					</div>
				}
				{
					this.props.errorCode === "500" &&
					<div className={"col s12 error"}>
						<div className={"col s4"}>
							<div className={"row"}><Icon className={"col s12 center primary-color-text"} size={"300"} iconName={"failure"}/></div>
						</div>
						<div className={"col s8"}>
							<h3>Entschuldigung, es ist ein unerwarteter Fehler aufgetretten!</h3>
							<p>Hier kommen Sie zurück zur</p>
							<NavLink className={"btn"} to="/"><Icon color="#fff" iconName={"leave"}/><span>Startseite</span></NavLink>
							<div className={"right bottom"}>
								<h2 className={"unset-padding"}>500 Error!</h2>
								<h3 className={"unset-padding"} style={{ marginLeft: 14 + "px" }}>Unerwartete Serverfehler!</h3>
							</div>
						</div>
					</div>
				}
				{
					!this.props.errorCode &&
					<div className={"col s12 error"}>
						<div className={"col s4"}>
							<div className={"row"}><Icon className={"col s12 center primary-color-text"} size={"300"} iconName={"search"}/></div>
						</div>
						<div className={"col s8"}>
							<h3>Entschuldigung, die Seite konnte nicht gefunden werden!</h3>
							<p>Hier kommen Sie zurück zur</p>
							<NavLink className={"btn"} to="/"><Icon color="#fff" iconName={"leave"}/><span>Startseite</span></NavLink>
							<div className={"right bottom"}>
								<h2 className={"unset-padding"}>404 Error!</h2>
								<h3 className={"unset-padding"} style={{ marginLeft: 14 + "px" }}>Seite nicht gefunden!</h3>
							</div>
						</div>
					</div>
				}
		</Page>;
		
	} // function render()
	
} // class

export default NoMatch;
